module.exports = __webpack_public_path__ + "img/4.00a21b0f.jpg";